import { ListingColumn } from './listing'
import { SortFilter } from './sortFilter'

export const getSortFunction =
	<T>(sort: SortFilter<T>, columns: ListingColumn<T>[]) =>
	(a: T, b: T) => {
		const sortColumn = columns.find((c) => c.sortColumnName === sort.column)
		if (sortColumn) {
			const valueA = sortColumn.value(a)
			const valueB = sortColumn.value(b)
			if (sortColumn.customSortCompare) {
				return valueA && valueB
					? sort.order === 'ASC'
						? sortColumn.customSortCompare(valueA, valueB)
						: sortColumn.customSortCompare(valueB, valueA)
					: 1
			} else {
				return valueA && valueB
					? sort.order === 'ASC'
						? String(valueA).localeCompare(String(valueB))
						: String(valueB).localeCompare(String(valueA))
					: 1
			}
		}
		return 0
	}
